import { render, staticRenderFns } from "./projectdialog.vue?vue&type=template&id=4953c45d&scoped=true&"
import script from "./projectdialog.vue?vue&type=script&lang=js&"
export * from "./projectdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953c45d",
  null
  
)

export default component.exports